import Navbar from "../../components/navbar";
import Footer from "../homepage/component/footer";
import Carousel from "../homepage/component/carousel";
import { BusinessHeroSection } from "../../components/business/heroSection";
import { BusinessFeaturedCards } from "../../components/business/featuredCards";
import { BusinessMiddleImage } from "../../components/business/middleImage";
import { SolutionCards } from "../../components/business/solutionCards";
import { VantPaymentSolutions } from "../../components/business/paymentSolutions";
import { VantPaymentSystem } from "../../components/business/paymentSystem";

const Business = () => {
  return (
    <>
      <Navbar />
      <BusinessHeroSection />
      <BusinessMiddleImage />
      <BusinessFeaturedCards />
      <div className="bg-white px-4 py-4 md:px-10 lg:px-10 xl:px-32 flex-col items-center">
        <h2 className="font-[600] text-[1rem] md:text-[2rem] text-center">
          Experience Flexibility and scalable Business
          <br className="hidden md:block" /> solution with{" "}
          <span className="text-[#32AE4C]">Vant for Business</span>
        </h2>
        <p className="text-[#6F6F6F] text-center text-[0.8rem] md:text-[1.1rem] my-[1rem]">
          At Vant, we are committed to revolutionize how African SMBs <br className="hidden md:block" />
          manage finances by providing intuitive
        </p>

        <SolutionCards />
      </div>
      <VantPaymentSolutions />
      <VantPaymentSystem/>

      <Carousel />
      <Footer />
    </>
  );
};

export default Business;
